import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-4-anniversary-transhipment-voyage',
  template: require('./linescape-4-anniversary-transhipment-voyage.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-4-anniversary-transhipment-voyage.component.scss')]
})
export class Linescape4AniversaryTranshipmentVoyageComponent extends BlogPage {
  title = "Linescape 4th Anniversary with Transhipment Voyage - Linescape";
  description = "Leading Sailing Schedules provider expands data offering with pre-searched transhipment schedules as a data feed.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-4-anniversary-transhipment-voyage/linescape-4-anniversary-transhipment-voyage.component.ts